var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGPayIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 15,
    viewBox: "0 0 36 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1348 7.67667V11.8691H15.825V1.52014H19.2989C20.1369 1.50363 20.9505 1.82549 21.5444 2.41968C22.7322 3.54205 22.8054 5.43193 21.6908 6.64508C21.642 6.69459 21.5932 6.74411 21.5444 6.79363C20.9342 7.37957 20.1857 7.67667 19.2989 7.67667H17.1348ZM17.1348 2.79106V6.40575H19.3315C19.8196 6.42225 20.2915 6.22419 20.6251 5.86932C21.3085 5.15133 21.2922 3.99595 20.5844 3.30272C20.2508 2.97262 19.8033 2.79106 19.3315 2.79106H17.1348Z",
    fill: "#3C4043"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5066 4.55762C26.4747 4.55762 27.2395 4.8217 27.8009 5.34163C28.3622 5.86155 28.6389 6.58779 28.6389 7.50384V11.8695H27.3859V10.8875H27.329C26.7839 11.6962 26.0679 12.1006 25.1649 12.1006C24.4001 12.1006 23.7492 11.8695 23.2367 11.4074C22.7323 10.9782 22.4475 10.3428 22.4638 9.67431C22.4638 8.93981 22.7404 8.36212 23.2855 7.92473C23.8306 7.48733 24.5628 7.27276 25.474 7.27276C26.2551 7.27276 26.8897 7.42131 27.3941 7.7019V7.39655C27.3941 6.94265 27.1988 6.51351 26.8571 6.21641C26.5073 5.90281 26.0598 5.7295 25.5961 5.7295C24.8638 5.7295 24.2862 6.04311 23.8631 6.67031L22.7079 5.93582C23.3262 5.01977 24.2618 4.55762 25.5066 4.55762ZM23.8143 9.69906C23.8143 10.0457 23.9771 10.3675 24.2455 10.5656C24.5384 10.7967 24.8964 10.9205 25.2625 10.9122C25.8157 10.9122 26.3446 10.6894 26.7351 10.2933C27.1663 9.88062 27.3859 9.39371 27.3859 8.83253C26.9792 8.50242 26.4096 8.33736 25.6774 8.34562C25.1486 8.34562 24.7011 8.47766 24.3432 8.7335C23.9933 8.98933 23.8143 9.31119 23.8143 9.69906Z",
    fill: "#3C4043"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8308 4.78809L31.4537 14.9802H30.1032L31.7303 11.415L28.8584 4.78809H30.2822L32.3568 9.87176H32.3812L34.407 4.78809H35.8308Z",
    fill: "#3C4043"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8384 6.76837C11.8384 6.36399 11.8058 5.95961 11.7407 5.56348H6.21655V7.84948H9.38137C9.2512 8.58397 8.82814 9.24419 8.20982 9.65683V11.1423H10.0973C11.2038 10.1107 11.8384 8.58397 11.8384 6.76837Z",
    fill: "#4285F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.21641 12.5785C7.79475 12.5785 9.12902 12.0503 10.0972 11.1425L8.20968 9.65701C7.68085 10.0201 7.00558 10.2264 6.21641 10.2264C4.68689 10.2264 3.3933 9.17835 2.92956 7.77539H0.985107V9.3104C1.97767 11.3158 4.00348 12.5785 6.21641 12.5785Z",
    fill: "#34A853"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.92963 7.77521C2.68556 7.04072 2.68556 6.2402 2.92963 5.49746V3.9707H0.985178C0.147193 5.64601 0.147193 7.62666 0.985178 9.30196L2.92963 7.77521Z",
    fill: "#FBBC04"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.21641 3.04672C7.0544 3.03022 7.85984 3.35207 8.46188 3.93801L10.1379 2.23795C9.07207 1.23112 7.67272 0.67819 6.21641 0.694695C4.00348 0.694695 1.97767 1.96561 0.985107 3.97103L2.92956 5.50603C3.3933 4.09482 4.68689 3.04672 6.21641 3.04672Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGPayIcon);
export default __webpack_public_path__ + "static/media/gPayIcon.ff975f39ee4bfa28bdd5b58e1f7f5dfa.svg";
export { ForwardRef as ReactComponent };